import styled from 'styled-components';

export const ModalOverlay = styled.div`
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: var(--white);
  border-radius: 5px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  max-width: 760px;
  min-height: 232px;
  position: relative;
  width: 90%;
`;

export const ModalHeader = styled.div`
  border-bottom: 1px solid var(--grey-400);
  box-shadow: 0 2px 10px rgba(34, 34, 34, 0.15);
  display: grid;
  padding: 10px 24px;
  place-items: center;
  position: relative;
`;

export const ModalTitle = styled.h2`
  color: var(--grey-900);
  font-family: var(--raleway);
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1.2px;
  margin: 0;
  text-transform: uppercase;
`;

export const ModalBody = styled.div`
  flex: 1 1 auto;
  font-family: var(--raleway);
  overflow-y: auto;
  padding: 37px 34px;
`;

export const ModalFooter = styled.div`
  background: var(--white);
  border-radius: 0 0 5px 5px;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding: 9px 11px;
`;
